import { Schema } from "@markdoc/markdoc";

export const alert: Schema = {
  render: "InstructionAlert",
  attributes: {
    type: {
      type: String,
      default: "info",
      matches: ["info", "warning", "tip"],
    },
    title: {
      type: String,
    },
  },
};
